import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Intro from './components/Intro';
import Marquee from './components/Marquee';
import PortfolioSlider from './components/PortfolioSlider';
import Philosophy from './components/Philosophy';
import Offerings from './components/Offerings';
import Statement from './components/Statement';
import Stats from './components/Stats';
import StudioSection from './components/StudioSection';
import Process from './components/Process';
import TestimonialSlider from './components/TestimonialSlider';
import Journal from './components/Journal';
import Availability from './components/Availability';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import './App.css';

function App() {
  return (
    <div className="site-shell">
      <Header />
      <main>
        <Hero />
        <Intro />
        <Marquee />
        <PortfolioSlider />
        <Philosophy />
        <Offerings />
        <Statement />
        <Stats />
        <StudioSection />
        <Process />
        <TestimonialSlider />
        <Journal />
        <Availability />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
